module.exports = __webpack_public_path__ + "img/file.7c49f3cf.svg";